import * as React from 'react'
import CloseGray from '../../../../assets/icons_new/CloseGray.svg'

import {
  useTimetable,
  useTimetableStore,
} from '@/modules/timetable/stores/timetableStore'
import { faBellSolid, FaIcon, faPrintSolid } from '@/lib/fa'
import usePrint from '../../hooks/usePrint'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const TimetabelViewControlBarSelected = ({
  resetAll,
  companyId,
}: {
  resetAll: () => void
  companyId: string
}) => {
  const {
    amount,
    selectedAlerts,
    setEditedAlert,
    setShowAddAlert,
  } = useTimetable()
  const alerts = useTimetableStore((s) => s.alerts)
  const { handlePrintConfirm, isGenerating, busyTooltip } = usePrint({
    companyId,
  })
  const { t } = useLocalize()
  const isMoreThanOne = selectedAlerts?.length > 1
  const editAlert = () => {
    if (isMoreThanOne) return
    const index = selectedAlerts?.[0]
    if (index == null) return
    const target = alerts[index]
    if (!target) return
    setEditedAlert(target)
    setShowAddAlert(true)
    resetAll()
  }
  return (
    <div className="tw-relative tw-z-20 tw-flex tw-w-full tw-justify-between tw-border-b-2 tw-border-primary tw-bg-[#F1F4FF] tw-px-4 tw-py-3.5 lg:tw-items-center">
      <div className="tw-absolute -tw-bottom-1.5 tw-left-3">
        <div className="tw-absolute -tw-top-1.5 !tw-z-10 tw-h-2 tw-w-2 tw-bg-[#F1F4FF]"></div>
        <div className="tw-h-2 tw-w-2 tw-rotate-45 tw-bg-primary"></div>
      </div>
      <div className="tw-flex tw-flex-col tw-items-start tw-gap-5 lg:tw-flex-row lg:tw-items-center">
        <div className="tw-flex tw-items-center tw-gap-5">
          <Info
            alertsLength={amount ?? 0}
            selectedLength={selectedAlerts?.length}
          />
        </div>
        <div
          title={busyTooltip}
          className={`tw-flex tw-items-center tw-gap-2 ${
            isGenerating
              ? 'tw-cursor-not-allowed tw-opacity-50'
              : 'tw-cursor-pointer'
          }`}
          onClick={() =>
            !isGenerating && handlePrintConfirm({ selected: true })
          }
        >
          <FaIcon icon={faPrintSolid} className="tw-text-primary" />
          <p className="tw-text-sm tw-font-semibold tw-text-primary">{t('common.print')}</p>
        </div>
        {!isMoreThanOne && (
          <div
            className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2"
            onClick={() => editAlert()}
          >
            <FaIcon icon={faBellSolid} className="tw-text-primary" />
            <p className="tw-text-sm tw-font-semibold tw-text-primary">
              Edytuj alert
            </p>
          </div>
        )}
      </div>
      <CloseButton onClick={() => resetAll()} />
    </div>
  )
}

export default TimetabelViewControlBarSelected


const CloseButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="tw-relative tw-cursor-pointer" onClick={() => onClick()}>
      <div className="tw-absolute -tw-top-1.5 tw-left-1/2 tw-z-0 tw-h-7 tw-w-7 tw--translate-x-1/2 tw-rounded-full tw-bg-white tw-p-2 tw-shadow lg:tw-top-1/2 lg:tw--translate-y-1/2"></div>
      <img className="tw-z-1 tw-relative" src={CloseGray} alt="Close Icon" />
    </div>
  )
}

const Info = ({ alertsLength, selectedLength }) => {
  const { t } = useLocalize()
  return (
    <p className="tw-space-x-2 tw-text-sm">
      <p className="tw-inline-block">{t('common.selected')}</p>
      <span className="tw-font-medium">{selectedLength}</span>/{alertsLength} :
    </p>
  )
}
